import Card, { CardProps } from '@carvana/ds-card';
import cx from 'classnames';
import { ReactElement, ReactNode } from 'react';
import {
  Content,
  Divider,
  Header,
  Heading,
  Icon,
  SwitchContainer,
  Text,
  TopLabel,
  Typography
} from './FinanceCard.styles';

type OwnProps = CardProps & {
  children?: ReactNode[] | ReactNode;
  disabled?: boolean;
  heading?: string;
  icon?: ReactNode;
  text?: ReactNode;
  Switch?: ReactNode | ReactElement | any;
  showDivider?: boolean;
};

export default function FinanceCard({
  disabled,
  heading,
  icon,
  text,
  children,
  Switch = false,
  showDivider = false,
  ...props
}: OwnProps) {
  const hasSwitch = !!Switch;

  return (
    <Card
      {...props}
      className={cx('flex flex-col', disabled && 'bg-background-weak-hover')}
      classes={{ content: 'flex flex-col justify-between gap-2xl grow px-2xl' }}
      disabled={disabled}
    >
      <TopLabel>
        <Heading>
          <Header>
            <Icon>{icon}</Icon>
            <Typography>{heading}</Typography>
          </Header>

          {hasSwitch && <SwitchContainer>{Switch}</SwitchContainer>}
        </Heading>
        <Text>{text}</Text>
      </TopLabel>
      {showDivider && <Divider data-testid="finance-card-divider" />}

      <Content>{children}</Content>
    </Card>
  );
}
